/**
 * Defines Auth State interface
 */
export interface GNUserPublic {
  userID: string,
  country: string,
  userName: string,
  userEmail: string,
  userRole: string,
  userPictureUrl: string,
  sinceTimestamp: number,
  settings: {
    isColaborationEmailSubscribed: boolean,
  },
  monthToDateUsageCost?: number
}

export interface GNSystemSettings {
  actualUEPluginVersion: string,
  latestUEPluginVersionDownloadURL: string,
}

export interface AuthState {
    // http state
    httpInProgress: boolean;
    httpUpdateInProgress: boolean;
    httpError: string;
    // auth server structure
    authToken: string;
    gnUser: GNUserPublic;
    systemSettings: GNSystemSettings;
  }
  
  /**
   * Defines Auth actions names
   */
  export const AUTH_IN_PROGRESS = 'AUTH_IN_PROGRESS'
  export const AUTH_UPDATE_IN_PROGRESS = 'AUTH_UPDATE_IN_PROGRESS'
  export const AUTH_UPDATE_TOKEN = 'AUTH_UPDATE_TOKEN'
  export const AUTH_ERROR = 'AUTH_ERROR'
  export const AUTH_CLEAR_ERROR = 'AUTH_CLEAR_ERROR'
  export const AUTH_LOGIN = 'AUTH_LOGIN'
  export const AUTH_LOGOUT = 'AUTH_LOGOUT'
  
  /**
   * Defines Auth actions interfaces
   */
  interface AuthInProgressAction {
    type: typeof AUTH_IN_PROGRESS;
  }
  interface AuthUpdateInProgressAction {
    type: typeof AUTH_UPDATE_IN_PROGRESS;
  }
  interface AuthUpdateTokenAction {
    type: typeof AUTH_UPDATE_TOKEN;
    authToken: string;
  }
  interface AuthErrorAction {
    type: typeof AUTH_ERROR;
    error: string;
  }
  interface AuthLoginAction {
    type: typeof AUTH_LOGIN;
    payload: AuthState;
  }
  interface AuthLogoutAction {
    type: typeof AUTH_LOGOUT;
  }
  interface AuthClearErrorAction {
    type: typeof AUTH_CLEAR_ERROR;
  }

  /**
   * Defines all suported actions for Auth
   */
  export type AuthActionTypes =
    AuthLoginAction |
    AuthInProgressAction |
    AuthUpdateInProgressAction |
    AuthUpdateTokenAction |
    AuthLogoutAction |
    AuthErrorAction |
    AuthClearErrorAction;
  
  /**
   * Defines AuthActionsInterface
   */
  export interface AuthActionsInterface {
    authLogout: () => void;
    authLogin: (googleAuthToken: string) => Promise<void>;
    authSetError: (error: string) => void;
    authClearError: () => void;
    authDeleteAccount: () => Promise<any | undefined>;
    authUpdateSettings: (settings: Partial<GNUserPublic['settings']>) => Promise<any | undefined>;
    authUpdateToken: (authToken: string) => Promise<void>;
  }